import type { HotelBookingTrackingProperties } from "./types";

export enum TripsTrackingEvents {
  viewed_my_trips = "b2b_viewed_my_trips",
  viewed_trip_summary = "b2b_viewed_trip_summary",
  tapped_cancel_hotel = "b2b_tapped_cancel_hotel",
  view_cancel_modal = "view_cancel_modal",
  tapped_confirm_cancel = "tapped_confirm_cancel",
  tapped_cancel_go_back = "tapped_cancel_go_back",
  tapped_contact_support = "b2b_tapped_contact_support",
  tapped_call_contact_support = "b2b_tapped_call_contact_support",
  complete_cancel_success = "complete_cancel_success",
  complete_cancel_failure = "complete_cancel_failure",
}

export type TripsHTSEventProperties<Properties> = Properties;

export const TripsEventName = {
  ...TripsTrackingEvents,
};
export type TripsEventName = typeof TripsEventName;

export type ViewedMyTrips = {
  name: TripsTrackingEvents.viewed_my_trips;
  properties: TripsHTSEventProperties<{
    hotel_bookings_active?: number;
  }>;
};

export type ViewedTripSummaryHotel =
  TripsHTSEventProperties<HotelBookingTrackingProperties> & {
    name: TripsTrackingEvents.viewed_trip_summary;
  };

export type TappedCancelHotel =
  TripsHTSEventProperties<HotelBookingTrackingProperties> & {
    name: TripsTrackingEvents.tapped_cancel_hotel;
  };

export type ViewCancelModalHotel =
  TripsHTSEventProperties<HotelBookingTrackingProperties> & {
    name: TripsTrackingEvents.view_cancel_modal;
  };

export type TappedConfirmCancelHotel =
  TripsHTSEventProperties<HotelBookingTrackingProperties> & {
    name: TripsTrackingEvents.tapped_confirm_cancel;
  };

export type TappedCancelGoBackHotel =
  TripsHTSEventProperties<HotelBookingTrackingProperties> & {
    name: TripsTrackingEvents.tapped_cancel_go_back;
  };

export type TappedContactSupportHotel =
  TripsHTSEventProperties<HotelBookingTrackingProperties> & {
    name: TripsTrackingEvents.tapped_contact_support;
  };

export type TappedCallContactSupportHotel =
  TripsHTSEventProperties<HotelBookingTrackingProperties> & {
    name: TripsTrackingEvents.tapped_call_contact_support;
  };

export type CompleteCancelSuccessHotel =
  TripsHTSEventProperties<HotelBookingTrackingProperties> & {
    name: TripsTrackingEvents.complete_cancel_success;
  };

export type CompleteCancelFailureHotel =
  TripsHTSEventProperties<HotelBookingTrackingProperties> & {
    name: TripsTrackingEvents.complete_cancel_failure;
  };

export type TripsHTSEvent =
  | ViewedMyTrips
  | ViewedTripSummaryHotel
  | TappedCancelHotel
  | ViewCancelModalHotel
  | TappedConfirmCancelHotel
  | TappedCancelGoBackHotel
  | TappedContactSupportHotel
  | TappedCallContactSupportHotel
  | CompleteCancelSuccessHotel
  | CompleteCancelFailureHotel;
